import type { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Input } from 'components/ui'
import type { ChangePasswordProps } from '.'
import s from './change-password.module.css'

const ChangePassword: FC<ChangePasswordProps> = ({ onSubmit }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, touched, isSubmitting },
    getValues,
    setError,
  } = useForm({
    mode: 'onChange',
  })

  const handleFormSubmit = (data: { password: string; confirmPassword: string }) => {
    const { password, confirmPassword } = data
    if (password !== confirmPassword) {
      setError('confirmPassword', {
        message: 'As senhas não são compatíveis',
      })
    } else {
      onSubmit({ password })
    }
  }

  return (
    <div className={s.root}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Input
          type="password"
          name="password"
          placeholder="Nova senha"
          error={errors?.password?.message}
          touched={touched?.password}
          maxLength={32}
          disabled={isSubmitting}
          ref={register({
            required: {
              value: true,
              message: 'Digite sua senha',
            },
            minLength: {
              value: 6,
              message: 'No mínimo 6 (seis) caracteres',
            },
            validate: {
              matchesNextPassword: (value) => {
                const { confirmPassword } = getValues()
                if (confirmPassword) {
                  return confirmPassword !== value ? 'A senha precisa ser igual' : true
                }
                return true
              },
            },
          })}
        />

        <Input
          type="password"
          name="confirmPassword"
          placeholder="Confirmar senha"
          error={errors?.confirmPassword?.message}
          touched={touched?.confirmPassword}
          maxLength={32}
          disabled={isSubmitting}
          ref={register({
            required: {
              value: true,
              message: 'Confirme a senha',
            },
            minLength: {
              value: 6,
              message: 'No mínimo 8 (oito) caracteres',
            },
            validate: {
              matchesPreviousPassword: (value) => {
                const { password } = getValues()
                return password !== value ? 'A senha precisa ser igual' : true
              },
            },
          })}
        />

        <Button variant="primary" type="submit" loading={isSubmitting}>
          Mudar senha
        </Button>
      </form>
    </div>
  )
}

export default ChangePassword
